import styled from 'styled-components';

export const TabContent = styled.div`
  min-height: 300px;
  margin-bottom: 4rem;

  &:empty {
    display: none;
  }
`;

export const PropertiesTabContent = styled(TabContent)`
  min-height: 750px;
`;

export const StatisticsTabContent = styled(TabContent)`
  min-height: 750px;
`;
